import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const authAuditApi = {
  list: (params) =>
    axios
      .get(`${API}/api/management/auth-audit`, { params, withCredentials: true })
      .then((r) => r.data),
  summary: (params) =>
    axios
      .get(`${API}/api/management/auth-audit/summary`, { params, withCredentials: true })
      .then((r) => r.data),
};
